module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/title_bg_2-b4255016cc15d98cc81e4abb5c1355b9.svg";